<script>
import topJumpLinks from '@/components/topJumpLinks';
import commonModelHelper from '@/scripts/commonModelHelper';

export default {
    props: {
        title: {},
        isFor: { default: 'header' },
        forReport: { default: false },
        exportXlsx: {},
        allowDownload: { default: true }
    },
    components: {
        topJumpLinks
    },
    render(h) {
        const vm = this;
        let leftSide = '';
        if (vm.isFor === 'header' && vm.forReport && vm.allowDownload)
            leftSide = h(
                'button',
                {
                    attrs: {
                        id: vm.bodyID,
                        class: 'hyperlink-button hide-on-print',
                        type: 'button'
                    },
                    on: {
                        click: vm.exportXlsx
                    }
                },
                'Download' + '\xa0' + 'Results'
            );
        else
            leftSide = vm.title
                ? h(
                      vm.isFor === 'header' ? 'h3' : 'h4',
                      {
                          attrs: {
                              id: vm.bodyID,
                              class: 'the-header col-xs-6'
                          }
                      },
                      vm.title
                  )
                : '';

        let rightSide = h('top-jump-links', {
            ref: 'select',
            props: {
                isFor: vm.isFor,
                forReport: vm.forReport
            }
        });

        return (
            <div class="the-header-container">
                {leftSide}
                {rightSide}
            </div>
        );
    },
    created: function () {
        const vm = this;
        if (vm.forReport && vm.isFor === 'header') {
            vm.bodyID = 'reportHeader';
        } else if (vm.forReport) {
            vm.bodyID = vm.isFor + 'Header';
        } else if (vm.isFor === 'header') {
            vm.bodyID = 'selectionHeader';
        } else {
            vm.bodyID = vm.isFor + 'Header';
        }
    },
    data: function () {
        return {
            bodyID: ''
        };
    },
    methods: { jumpTo }
};

// function exportXlsx(e) {
//   const vm = this;
//   if (e) e.preventDefault();
//   metricsHelper.reportDownloaded();
//   let wb = current.xlsxBuilder.createWorkbook(vm.reportModel, store.state, vm);
//   if (wb) XLSX.writeFile(wb, "sheetjs.xlsx");
// }

// commonModelHelper.jumpTo($event, $parent.$refs.select)
function jumpTo($event) {
    const vm = this;
    commonModelHelper.jumpTo($event, vm.$refs.select, 'Who knows');
}
</script>

<style scoped>
div.the-header-container {
    overflow: hidden;
    width: 100%;
    /* border: 2px solid yellowgreen; */
}

.the-header {
    overflow: hidden;
    width: 100%;

    margin-top: 0px;
    margin-bottom: 0px;
    display: block;

    float: left; /* Try removing this later */
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    /* padding-left: 15px; */
    padding-top: 9px;
    padding-left: 0;
    width: 50%;
}

@media (min-width: 768px) {
    .the-header {
        width: 50%;
    }
}

h4 {
    margin-bottom: 0px;
    margin-top: 0px;
    width: auto;
    font-size: 18px;
    font-weight: 400;
}

@media print {
    .hide-on-print {
        display: none;
    }
}
</style>
